<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative">
  <mat-toolbar-row class="relative">
    <button mat-icon-button (click)="toggleSideBar()">
      <mat-icon>menu</mat-icon>
    </button>

    <span class="headerTitleSm"> LIVAS </span>
    <span class="headerTitleLg"> LIVAS - Control de acceso </span>

    <div class="flex flex-row absolute right-0 content-center">
      <ul class="flex-row flex content-center gap-2">
        <li *ngIf="imgUrl">
          <div
            style="width: 100%; height: 100%; min-width: 40px"
            [style.background]="imgUrl"
            mat-header-avatar
            class="mat-header-avatar-img"
          ></div>
        </li>

        <li>
          <button
            mat-icon-button
            routerLink="/in/perfilEmpresa"
            *ngIf="hasPermision('in/perfilEmpresa')"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </li>
        <li>
          <button  mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>person_outline</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="signout()">
              <mat-icon>exit_to_app</mat-icon>
              Salir
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
